import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#146ec8',
        secondary: '#254d7c',
        accent: colors.amber.accent4,
      },
    },
  },
});
